export default "__VITE_ASSET__DV$i3CdS__"